import React, { ReactElement } from "react";

export default function Settings(): ReactElement {
    return (
        <div>
            <h2>Settings</h2>
        </div>
    );
}